// Business.js
import Image from "next/image";


const Business = () => {
  const pointers = [
    {
      icon: "https://d3kl8zsmmx4oop.cloudfront.net/si_Movie_e70fcd3f84.svg",
      title: "Self-paced video content",
      description:
        "Master new skills on your schedule with our flexible, self-paced video content.",
    },
    {
      icon: "https://d3kl8zsmmx4oop.cloudfront.net/si_Target_c6f22015fa.svg",
      title: "Office hours with Mentors for clearing blockers",
      description:
        "Overcome challenges fast with dedicated mentor office hours.",
    },
    {
      icon: "https://d3kl8zsmmx4oop.cloudfront.net/si_Copy_alt_6d34ac6c00.svg",
      title: "Project driven approach to achieve outcomes",
      description:
        "Gain practical skills through our project-driven approach for real results.",
    },
    {
      icon: "https://d3kl8zsmmx4oop.cloudfront.net/si_User_alt_cc0bd5ef2f.svg",
      title: "Access to network of 1000+ learners",
      description:
        "Tap into our vibrant network of learners, enhancing your learning experience.",
    },
  ];

  return (
    <div className="w-full py-10 md:py-20" id="business">
      <div className="w-[90%] md:w-[80%] mx-auto">
        {/* Header Section */}
        <div className="mb-8 md:mb-12">
          <p className="text-sm md:text-base uppercase font-medium tracking-wide text-gray-600 mb-4">
            ENTERPRISE LEARNING THAT DELIVERS
          </p>
          <h2 className="text-3xl md:text-[36px] font-medium mb-8">
            Why learn with GrowthSchool?
          </h2>
        </div>

        {/* Pointer Section */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
          {pointers.map((pointer, index) => (
            <div key={index} className="flex items-start gap-4 md:p-4">
              <div
                className="flex-shrink-0 w-[74px] h-[74px] rounded-xl flex items-center justify-center"
                style={{ backgroundColor: "rgba(3, 10, 33, 0.05)" }}
              >
                <Image
                  src={pointer.icon}
                  alt={pointer.title}
                  width={42}
                  height={42}
                  sizes="42px"
                />
              </div>
              <div>
                <div className="text-base font-medium mb-2">
                  {pointer.title}
                </div>
                <p className="text-gray-600 font-normal text-sm md:text-base">
                  {pointer.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
  
    </div>
  );
};

export default Business;